<template>
  <div>
    <div class="pb-6">
      <div v-if="dense" class="mb-16">
        <div class="mt-3 mb-8">
          <table class="w-100">
            <thead>
              <th class="pl-0 pb-4"></th>
              <th
                v-for="(column, i) in comparison.columns"
                :key="i"
                class="vertical-align-bottom text-center text-capitalize"
                style="width: 150px"
                v-html="column.text"
              ></th>
            </thead>
            <tr v-for="(row, i) in comparison.data" :key="i">
              <td class="py-4 d-flex" style="min-width: 400px">
                <v-chip
                  v-if="
                    row.question.questionNumber &&
                      row.question.questionNumber.length > 0
                  "
                  color="secondary"
                  class="text-capitalize mr-4 flex-shrink-0"
                >
                  {{ row.question.questionNumber }}
                </v-chip>
                <survey-question-text
                  :text="row.question.text"
                ></survey-question-text>
              </td>

              <td
                class="text-right text-no-wrap"
                v-for="(column, ii) in comparison.columns"
                :key="ii"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <comparison-button
                        :value="row.colData[ii] ? row.colData[ii].val : null"
                      ></comparison-button>
                    </div>
                  </template>
                  <span v-html="column.text"></span>
                </v-tooltip>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <template v-else>
        <div v-for="(row, i) in comparison.data" :key="i" class="mb-16">
          <div class="mt-3 mb-8">
            <div
              class="font-weight-bold d-flex text-left mb-4"
              v-if="smallScreen"
            >
              <v-chip
                v-if="
                  row.question.questionNumber &&
                    row.question.questionNumber.length > 0
                "
                color="secondary"
                class="text-capitalize mr-2 flex-shrink-0"
                >{{ row.question.questionNumber }}</v-chip
              >
              <survey-question-text
                :text="row.question.text"
                class="mt-1"
              ></survey-question-text>
            </div>
            <table>
              <thead>
                <th class="pl-0 pb-4">
                  <div
                    class="font-weight-bold d-flex text-left"
                    v-if="!smallScreen"
                  >
                    <v-chip
                      v-if="
                        row.question.questionNumber &&
                          row.question.questionNumber.length > 0
                      "
                      color="secondary"
                      class="text-capitalize mr-2 flex-shrink-0"
                      >{{ row.question.questionNumber }}</v-chip
                    >
                    <survey-question-text
                      :text="row.question.text"
                      class="mt-1"
                    ></survey-question-text>
                  </div>
                </th>
                <th
                  class="vertical-align-bottom text-right text-capitalize text-no-wrap"
                >
                  Agree Percentage
                </th>
              </thead>

              <tr v-for="(column, i) in comparison.columns" :key="i">
                <td class="w-100 pl-10" v-html="column"></td>
                <td class="text-right text-no-wrap">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <comparison-button
                          class="my-1"
                          :value="row.colData[i].val"
                        ></comparison-button>
                      </div>
                    </template>
                    <span v-html="column.text"></span>
                  </v-tooltip>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
$blueFill: rgba(101, 146, 230, 0.15);
$greyFill: rgba(0, 0, 0, 0.05);

table {
  border-collapse: collapse; /* Remove cell spacing */

  thead {
    th {
      vertical-align: bottom;
      text-align: center;
      padding-top: 0.5rem;
      border-radius: 0.5rem 0.5rem 0 0;
      padding: 0.5rem 1rem 0.25rem 1rem;

      &:nth-child(even) {
        background: $greyFill;
      }
    }
  }

  th,
  td {
    padding: 0.25rem 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    text-align: left;
  }

  tr,
  tfoot {
    &:nth-child(odd) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
    &:nth-child(even) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
  }

  tr {
    &:hover {
      background: rgba(0, 0, 0, 0.15) !important;

      td {
        border-color: rgba(0, 0, 0, 0.25);
      }
    }

    &:nth-child(even) {
      background: $blueFill;
    }
  }

  tfoot {
    td {
      border-radius: 0 0 0.5rem 0.5rem;
      padding: 0.5rem;
    }
  }
}
</style>

<script>
import numeral from "numeral";

import ComparisonButton from "./QuestionReport.AgreeAnalysis.ComparisonButton.vue";
import SurveyQuestionText from "./Survey.Question.Text.vue";

export default {
  components: {
    ComparisonButton,
    SurveyQuestionText,
  },
  filters: {
    percentage(val) {
      return numeral(val).format("0.00%");
    },
  },
  data: () => ({}),
  props: {
    comparison: Object,
    dense: Boolean,
  },
  computed: {
    smallScreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
